<div style="margin-top:300px;">
<mat-spinner style="margin:0 auto;" 
    mode="indeterminate"></mat-spinner>
</div>
<div style="text-align:center;font-size:24px;margin-top:50px;">
Loading...
</div>